import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/heroCarousel/heroCarousel.js';
import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import { fade } from 'utils/bolt/transitions';
import Store from 'store/store';
import s from 'components/bolt/hub/components/heroCarousel/heroCarousel.sss';

export default class HeroCarousel extends BaseComp.default {

	trackHeroClick(title, label) {
		Store.emit('CUSTOM_EVENT', {
			category: Store.get().activePage.replace('Scroll', ''),
			action: 'hero_button-click_' + title,
			label: label
		});
	}

	async onSlideClick({ target }, index, slidePath, slideTite) {
		const tile = this.slideRefs[`slide${index}`];
		
		if (tile.contains(target) && (this.buttons && !this.buttons.contains(target))) {
			if (slidePath) {
				Store.emit('CUSTOM_EVENT', {
					category: Store.get().activePage.replace('Scroll', ''),
					action: 'hero_slide-click_' + slideTite,
					label: '-'
				});

				if (slidePath.startsWith('http') || slidePath.startsWith('mailto:')) {
					let link = document.createElement('a');
					link.href = slidePath;
					link.target = '_blank';
					link.style.display = 'none';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					await fade(document.getElementById('mainScroll'), 'out', 500);
					navigateInternally(slidePath);
					fade(document.getElementById('mainScroll'), 'in', 700);
				}
			}
		}
	}

	renderButton(button, title) {
		// button.href should be legacy as it's not in the schema
		const link = button.link || button.href || ''; 

		if (link.startsWith('http')) {
			return (
				<a
					href={link}
					target="_blank"
					class={joinClasses(s.cta, s.watch)}
					onClick={() => this.trackHeroClick(title, button.label)}
				>
					{button.label}
				</a>
			);
		}

		return (
			<button
				class={joinClasses(s.cta, s.watch)}
				onClick={async () => {
					this.trackHeroClick(title, button.label);
					if (button.videoOverlay) {
						return Store.emit('ENABLE_TRAILER_OVERLAY', button.videoOverlay);
					}
					if (button.pageId) {
						await fade(document.getElementById('mainScroll'), 'out', 500);
						navigateInternally(button.pageId);
						fade(document.getElementById('mainScroll'), 'in', 700);
					}
					if (button.link) {
						await fade(document.getElementById('mainScroll'), 'out', 500);
						navigateInternally(button.link);
						fade(document.getElementById('mainScroll'), 'in', 700);
					}
				}}
			>
				{button.label}
			</button>
		);
	}
}
